import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { closeOffCanvas, FormLayoutComponent, IFormLayout, IFormLayoutContent, IFormLayoutFooter, IFormLayoutHeader, IPolymorphicControlMeta, ITab, OffCanvasPlacement, OptimaOffCanvasService, PolymorphicControlService, PolyMorphicControlTypes, ToastService } from '@optima-stride-ai/optima-components';
import { DashboardTypes, iDashboard } from '@optima-stride-ai/optima-app-framework';
import { faker } from '@faker-js/faker';
import { DashboardStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { OffcanvasService } from '@coreui/angular';
import { FieldTypes } from '@optima-stride-ai/core';
import { DashboardService } from '../service/dashboard.service';
import { AppStateService } from '../../../../services/state-store/app-state';



@Component({
  selector: 'app-form-add-dashboard',
  imports: [FormLayoutComponent],
  templateUrl: './form-add-dashboard.component.html',
  styleUrl: './form-add-dashboard.component.sass',
})

export class FormAddDashboardComponent implements OnInit {

 formLayout!: IFormLayout;
  private isAPICallInProgress: boolean = false;
  private tabConfig : ITab | null = null;
  private unpinTabId: string | undefined = undefined;
  private dashboardData: iDashboard = {
    id: '',
    uuid: faker.string.uuid(),
    label: '',
    pinAsTab: false,
    icon: '',
    tabDisplayOrder: 0,
    type: DashboardTypes.MyDashboard,
    isAdHocTab: false,
  };
  
  private readonly polymorphicControlService = inject(PolymorphicControlService);
  private readonly dashboardStateStoreService = inject(DashboardStateStoreService);
  private readonly dashboardService = inject(DashboardService);
  private readonly toastService = inject(ToastService);
  private readonly offCanvasFormService = inject(OptimaOffCanvasService);
  private readonly offcanvasService = inject(OffcanvasService);
  private readonly appStateService = inject(AppStateService);

  constructor() {
    this.tabConfig = this.appStateService.selectedTabConfig;
    this.unpinTabId = this.appStateService.unpinTabId;
    if (this.tabConfig) {
      this.dashboardData.label = this.tabConfig.title || '';
      this.dashboardData.icon = this.tabConfig.icon || '';
      this.dashboardData.pinAsTab = this.tabConfig.pinned || false;
    }
    this.appStateService.unpinTabId = undefined;
    this.appStateService.selectedTabConfig = null;
  }

  ngOnInit(): void {
    this.buildFormLayout();
  }

  private buildFormLayout() {
    const layout: IFormLayout = {
      header: this.buildFormLayoutHeader(),
      content: this.buildFormLayoutContent(),
      footer: this.buildFormLayoutFooter(),
      cssClass: 'ben-form-dashboard'
    };
    this.formLayout = layout;
  }

  private buildFormLayoutHeader(): IFormLayoutHeader {
    return {
      title: this.tabConfig?.isTemporary ? 'Add Dashboard' : 'Edit Dashboard',
    };
  }

  private buildFormLayoutContent(): IFormLayoutContent {
    return {
      fieldItems: this.buildFormFields()
    };
  }

  private buildFormLayoutFooter(): IFormLayoutFooter {
    return {
      actions: [
        {
          label: this.tabConfig?.isTemporary?'Create Dashboard':"Save Changes",
          icon: this.tabConfig?.isTemporary?'cilPlus':"cilSave",
        },
      ]
    };
  }

  private populateDashboardFormWithValues(): iDashboard {
    this.dashboardData.id = this.tabConfig?.id || '';
     this.dashboardData.label = this.formLayout.content?.fieldItems?.find(f => f.id === 'label')?.value || '';
     this.dashboardData.icon = this.formLayout.content?.fieldItems?.find(f => f.id === 'icon')?.value || '';
     this.dashboardData.pinAsTab = (this.formLayout.content?.fieldItems?.find(f => f.id === 'pinAsTab')?.value || false) as unknown as boolean;
     return this.dashboardData;
  }

  get dashboardBizEntityFormValues(): iDashboard {
    return this.populateDashboardFormWithValues();
  }

  get isFormValid(): boolean {
    if (this.formLayout && this.formLayout.content && this.formLayout.content.fieldItems) {
      for (const field of this.formLayout.content.fieldItems) {
        if (field.fieldMeta?.isRequired) {
          const fieldValue = field.value;
          field.touched = true;

          // Check if field is empty
          if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
            return false;
          }

          // Check if field has inputPattern validation
          if (field.fieldMeta.inputPattern && fieldValue) {
            const pattern = new RegExp(field.fieldMeta.inputPattern);
            if (!pattern.test(fieldValue.toString())) {
              return false;
            }
          }
        }
      }
      return true;
    }
    return false;
  }

  onCreateDashboard(): void {
    if(!this.isFormValid) {
      this.toastService.toast('Please fill out all required fields correctly.');
      return;
    }

    if (this.isAPICallInProgress) {
      this.toastService.toast('Please wait, operation in progress.');
      return;
    }

    this.setAPICallInProgress(true);
    this.populateDashboardFormWithValues();
    if(this.tabConfig && this.tabConfig.isTemporary) {
    this.dashboardStateStoreService.create(this.dashboardData)?.then(() => {
      if(this.unpinTabId){
              this.unpinTabIfNeeded(this.unpinTabId);
      }

      this.afterSubmissionSucceeded();
      this.setAPICallInProgress(false);
    }).catch((error) => {
      this.handleSubmissionError(error);
      this.setAPICallInProgress(false);
    });}
    else{
      this.dashboardStateStoreService.update(this.dashboardData)?.then(() => {
        this.afterSubmissionSucceeded();
        this.setAPICallInProgress(false);
      }).catch((error) => {
        this.handleSubmissionError(error);
        this.setAPICallInProgress(false);
      });
    }
  }

    private unpinTabIfNeeded(unpinTabId?: string) {
    if (unpinTabId) {
      this.dashboardService.pinDashboardTab(unpinTabId, false, this.dashboardStateStoreService);
    }
  }
  private setAPICallInProgress(inProgress: boolean): void {
    this.isAPICallInProgress = inProgress;
    //TO Do : This diable/enable the submit button in the footer should be handled using key instead of index 0
    if (this.formLayout && this.formLayout.footer && this.formLayout.footer.actions.length > 0) {
    this.formLayout.footer.actions[0].isDisabled = inProgress;
  }
  }

  private afterSubmissionSucceeded(): void {
    closeOffCanvas(this.offCanvasFormService, this.offcanvasService, OffCanvasPlacement.End, true);
    this.toastService.toast(this.tabConfig?.isTemporary ? 'Dashboard created successfully.' : 'Dashboard updated successfully.');
  }

  private handleSubmissionError(error: unknown): void {
    // console.error('Error creating dashboard:', error);
    // this.toastService.toast('Failed to create dashboard. Please try again.');
  }

  private buildFormFields(): IPolymorphicControlMeta[] {
    const fields: IPolymorphicControlMeta[] = [];

    const dashboardName = this.polymorphicControlService.getC({
      type: PolyMorphicControlTypes.text,
      label: 'Dashboard Name',
      id: 'label',
      icon: 'cilImagePlus',
      value: this.dashboardData.label,
      placeholder: 'Enter name',
      fieldMeta: {
        id: 'name',
        name: 'Name',
        type: FieldTypes.text,
        label: 'Name Field',
        isRequired: true,
        inputPattern: '^\\S.{0,48}\\S$|^\\S{2}$'
      },
      customValidationMessages: {
        pattern: "Name must be 2-50 characters. Leading and trailing spaces are not allowed.",
      }, 

    });

      const icon: IPolymorphicControlMeta = this.polymorphicControlService.getC(this.polymorphicControlService.getC({
      id: 'icon',
      type: PolyMorphicControlTypes.icons,
      label: 'Icon',
      icon: 'cil3d',
      value: this.dashboardData.icon,
      placeholder: 'Enter icon name',
      disabled: false,
      fieldMeta: {
        id: 'icon',
        name: 'Icon',
        type: FieldTypes.text,
        label: 'Icon Field',
        isRequired: true,
      },
    }));

    const pinAsTab = this.polymorphicControlService.getC({
      id: 'pinAsTab',
      type: PolyMorphicControlTypes.checkBox,
      label: 'Pin as a tab',
      icon: 'cilPin',
      value: this.dashboardData.pinAsTab
    });



    fields.push(dashboardName, icon, pinAsTab);
    return fields;
  }

}
